// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgb(0 0 0 / 75%);
  transition: opacity 500ms;
  z-index: 10;

  .box {
    position: relative;
    width: 30%;

    margin: 70px auto;
    border-width: 1px;
    border-style: solid;
    border-radius: 0.3rem;

    background-clip: padding-box;
    background-color: var(--color-background-header);

    transition: all 3s ease-in-out;

    & > h2 {
      padding: 0.2em;
    }

    & > div {
      width: 100%;

      background-color: white;
      color: black;

      padding: 1rem;
      border-top: 1px solid #e9ecef;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./frontend/widget/popup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kCAAkC;EAClC,yBAAyB;EACzB,WAAW;;EAEX;IACE,kBAAkB;IAClB,UAAU;;IAEV,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;;IAErB,4BAA4B;IAC5B,gDAAgD;;IAEhD,8BAA8B;;IAE9B;MACE,cAAc;IAChB;;IAEA;MACE,WAAW;;MAEX,uBAAuB;MACvB,YAAY;;MAEZ,aAAa;MACb,6BAA6B;IAC/B;EACF;AACF","sourcesContent":[".popup {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgb(0 0 0 / 75%);\n  transition: opacity 500ms;\n  z-index: 10;\n\n  .box {\n    position: relative;\n    width: 30%;\n\n    margin: 70px auto;\n    border-width: 1px;\n    border-style: solid;\n    border-radius: 0.3rem;\n\n    background-clip: padding-box;\n    background-color: var(--color-background-header);\n\n    transition: all 3s ease-in-out;\n\n    & > h2 {\n      padding: 0.2em;\n    }\n\n    & > div {\n      width: 100%;\n\n      background-color: white;\n      color: black;\n\n      padding: 1rem;\n      border-top: 1px solid #e9ecef;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
